import React from "react";
import PropTypes from "prop-types";

import Modal from "../../../Modal";
import Button from "../../../Button";

const InfoFooter = ({
  onClose,
  onConfirm,
  confirmButtonText,
  confirmButtonVariant,
}) => {
  const onClickConfirm = React.useCallback(() => {
    onConfirm && onConfirm();
    onClose();
  }, [onClose, onConfirm]);

  return (
    <Modal.Footer className="justify-content-end">
      <Button
        variant={confirmButtonVariant}
        onClick={onClickConfirm}
        className="m-0"
      >
        {confirmButtonText}
      </Button>
    </Modal.Footer>
  );
};

InfoFooter.propTypes = {
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func,
  confirmButtonText: PropTypes.string,
  confirmButtonVariant: PropTypes.string,
};

InfoFooter.defaultProps = {
  confirmButtonText: "Ok",
  confirmButtonVariant: "primary",
};

export default InfoFooter;
